import {
  workbookPivotSpecSchema,
  type WorkbookDefinition,
  type WorkbookPivotSheet,
} from '@erp/shared-types';
import { tableNames, unusedName } from '../workbookNames';

/**
 * A new, empty pivot Worksheet summarizing `input`, named after it
 * ("Orders sheet pivot", then "… pivot 2") among every table's names.
 */
export function newPivotSheet(
  definition: Pick<WorkbookDefinition, 'sources' | 'sheets'>,
  input: { id: string; name: string },
  id: string,
  suffix: string,
): WorkbookPivotSheet {
  const name = unusedName(tableNames(definition), `${input.name} ${suffix}`);
  return {
    id,
    name,
    folder: '',
    kind: 'pivot',
    inputId: input.id,
    pivot: workbookPivotSpecSchema.parse({}),
  };
}
